import Header from '@/pages/layouts/header';
import styles from './error-boundary.module.scss';
import errorImage from '@/assets/images/error-page.png?url';
import { Button } from '@/components/button';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useRouteError } from 'react-router';

export const ErrorBoundary = () => {
  const e = useRouteError();
  const { t } = useTranslation();
  const backToHome = () => {
    window.location.href = import.meta.env.BASE_URL;
  };
  const refreshPage = () => {
    window.location.reload();
  };

  useEffect(() => {
    console.error('Routing Error:', e);
  }, [e]);
  return (
    <div className={styles.container}>
      <Header className={styles.header} />
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <img className={styles.image} src={errorImage} alt="error" />
          <h1 className={styles.title}>{t('error.notLoad.title')}</h1>
          <div className={styles.buttonGroup}>
            <Button variant="default" size="md" onClick={backToHome}>
              {t('error.notLoad.backHome')}
            </Button>
            <Button variant="primary" size="md" onClick={refreshPage}>
              {t('error.notLoad.refreshPage')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
